import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';

import edit from './inc/edit';

registerBlockType('vortex-blocks/heading-with-label', {
  edit,
  save: () => <InnerBlocks.Content />,
});
